import { render } from "./HealthDiary.vue?vue&type=template&id=37528fc9"
import script from "./HealthDiary.vue?vue&type=script&lang=js"
export * from "./HealthDiary.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__